import React, { useEffect } from 'react';
import { SxProps, Theme } from '@mui/material';

import EmptyResults from '../../../components/common/EmptyResults';

interface InvoiceEmptyResultsProps {
  isLoading: boolean;
  hasRows: boolean;
  hasBillingRole: boolean;
  useTablePresets?: boolean;
  sx?: SxProps<Theme>;
}

function InvoiceEmptyResults({ isLoading, hasRows, hasBillingRole, useTablePresets, sx }: InvoiceEmptyResultsProps) {
  const [emptyResultsHeader, setEmptyResultsHeader] = React.useState<string | null>(null);
  const [emptyResultsText, setEmptyResultsText] = React.useState<string | null>(null);

  useEffect(() => {
    if (hasBillingRole) {
      if (!isLoading && !hasRows) {
        setEmptyResultsHeader(null);
        setEmptyResultsText(null);
      }
    } else {
      setEmptyResultsHeader('Invoices are disabled');
      setEmptyResultsText('Ask your pool service provider about enabling billing features');
    }
  }, [hasRows, hasBillingRole]);

  return (
    <EmptyResults
      sx={sx}
      hasRows={hasRows}
      isLoading={isLoading}
      useTablePresets={useTablePresets}
      showDefaultIcon={false}
      headerText={emptyResultsHeader}
      text={emptyResultsText}
    />
  );
}

export default InvoiceEmptyResults;
